/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutSavePersonalizationMutationRequest, PutSavePersonalizationMutationResponse, PutSavePersonalizationPathParams, PutSavePersonalizationQueryParams, PutSavePersonalization400, PutSavePersonalization404 } from "../../models/PutSavePersonalization";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPutSavePersonalizationUrl({ configurationId, printOptionCode }: { configurationId: PutSavePersonalizationPathParams["configurationId"]; printOptionCode: PutSavePersonalizationPathParams["printOptionCode"] }) {
  const res = { method: 'PUT', url: `/api/v1/configurations/${configurationId}/print-options/${printOptionCode}/personalization` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:configurationId/print-options/:printOptionCode/personalization}
 */
export async function putSavePersonalization({ configurationId, printOptionCode, data, params }: { configurationId: PutSavePersonalizationPathParams["configurationId"]; printOptionCode: PutSavePersonalizationPathParams["printOptionCode"]; data: PutSavePersonalizationMutationRequest; params?: PutSavePersonalizationQueryParams }, config: Partial<RequestConfig<PutSavePersonalizationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PutSavePersonalizationMutationResponse, ResponseErrorConfig<PutSavePersonalization400 | PutSavePersonalization404>, PutSavePersonalizationMutationRequest>({ method : "PUT", url : getPutSavePersonalizationUrl({ configurationId, printOptionCode }).url.toString(), params, data : requestData, ... requestConfig })  
  return res.data
}